import React, {useState, useEffect} from "react";

// reactstrap components
import {
  Button, InputGroup, InputGroupText,
  Card,Badge, Spinner,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useSelector } from 'react-redux'

import {fieldvalidator} from '../../../helpers/validate'
import {customStyles} from '../../../helpers/mycomps'

import Select from "react-select";
import BtypeTable from "./BtypeTable";


function Btype(props) {
    const catlist  = useSelector(state => state.featureStore.featureData).map(x => {
        return {
              label :x.categoryName.en  , value : x.categoryCode, 
              labelfr : x.categoryName.fr, labelar : x.categoryName.ar,
              features : x.features, unit : x.unit
            }
          })

    const [vtype , setVtype] = useState({typeCode : "", typeName: { en : "", fr : "", ar : ""}})   
    const [vtypeList , setVtypeList] = useState([])    
    const [categories, setCategories] = useState({categoryCode : "", categoryName : {en : "", fr : "", ar : ""}})
    const [showProcessing , setShowProcessing] = useState(false)
    const [alert, setAlert] = React.useState(null);
    
       
   useEffect(() => {
    populateTypes()
},[])




    const populateTypes = () => {
        setShowProcessing(true)
        props.API.get(`tenant/btypes/${"-"}`, { headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
          //  basicAlert(res.data.message)
            setShowProcessing(false)
            //setVtypeList(res.data)
            let data = res.data.map((aa,k) =>{
              return {
                id: k,
                categoryCode: aa.categoryCode ,
                catagoryName: aa.categoryName.en + " - " + aa.categoryName.ar ,
                vtypeName : aa.typeName.en + " - " + aa.typeName.ar, 
                vtypeCode : aa.typeCode,
                actions: (
                    // we've added some custom button actions
                    <div className="actions-right">
                                      
                      <Button
                        onClick={() => {
                          let obj = data.find((o) => o.id === k);
                            removeType(obj.vtypeCode)
                        }}
                        color="warning"
                        size="sm"
                        className="btn-icon btn-link remove"
                      >
                        <i className="fa fa-remove" />
                      </Button>
                    </div>
                  ),
            }
        })
            setVtypeList(data)
                            
          }).catch(function (error) {
            setShowProcessing(false)
              
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }
           // console.log(error)
           // basicAlert("Error fetching vehicle data")
          }) 
    }     
    
    const addType = () => {
      setShowProcessing(true)
      if(fieldvalidator(vtype.typeName.en )){
        setShowProcessing(false)
        props.swal("Type Name Required.")
        return
      }

        props.API.post(`tenant/cbtype`, {btype : vtype, categories: categories },{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
              props.swal(res.data.message)
              setShowProcessing(false)       
     //         populateTypes()       
          }).then(t => {
           cout("Created / Updated Vehicle body Type")
          }).catch(function (error) {
            setShowProcessing(false)
              console.log(error)
              props.swal(error.response.data.message)
          }) 
    }

    const cout = (xcc) => {
      window.location.reload(false)
      
    };  

    const cinputConfirmAlert = (xcc) => {
        let mtext = "Create Vehicle Body Type"
        
        props.swal({
          title: "Are you sure?",
          text: mtext,
          icon: "warning",
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
            addType();
          }
        });
      };  
    
    const removeType = (typeCode) => {
        let mtext = "Remove Vehicle Type"
        props.swal({
          title: "Are you sure?",
          text: mtext,
          icon: "warning",
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
            props.API.post(`tenant/rbtype`, {typeCode : typeCode },{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
              //           populateTypes()  
                         props.swal(res.data.message)
                                       
                       }).then(t => {
                         cout("Removed Vehicle Type")
                       }).catch(function (error) {
                           
                           console.log(error)
                             
                        if(error.response.status === 401){
                          props.swal("Unauthorized, please login again.").then(t => {
                              props.history.push(`/auth/login`)
                          })   
                        }else{
                          props.swal("Error deleting Vehicle Types.")
                        }
                         
                       }) 
          }
        });
       }

   
     
     return (
      
        <div className="content">
             
        <Row>
            {/** This will contain Table */}
            
            <Col sm="12" md="5">
             {showProcessing && props.Spin}
             <Card>
             <CardHeader>
             <Row>
                     <Col >
                     <FormGroup>
                           <label>Select Catagory </label>
                                 <Select options={catlist} styles={customStyles} 
                                         
                                        onChange={e=> {
                                            setCategories({categoryCode: e.value, categoryName : {en: e.label, fr: e.labelfr, ar: e.labelar} }); 
                                            
                                          }}
                                              
                                        />
                           
                     </FormGroup>
                  
                     </Col>
             </Row>
          
            
            <hr />                                 
             <h6>Body Type</h6>
             <span>* Type of vehicle body</span>
             <Row>
                     <Col className="pr-1" md="6">
                     <FormGroup>
                         <label>Name EN</label>
                         <Input
                         maxLength={20}
                         value={vtype.typeName.en}
                         placeholder="Type Name"
                         type="text"
                         onChange = {x => {
                            setVtype({...vtype , typeName : {...vtype.typeName , en  :x.target.value }  })
                            
                         }}
                         />
                     </FormGroup>
                     </Col>{/** 
                     <Col className="pr-1" md="4">
                     <FormGroup>
                         <label>Nom</label>
                         <Input
                         maxLength={20}
                            value={vtype.typeName.fr}
                         placeholder="Nom"
                         type="text"
                         onChange = {x => {
                            setVtype({...vtype , typeName : {...vtype.typeName , fr  :x.target.value }  })
                         }}
                         />
                     </FormGroup>
                     </Col>*/}
                     <Col className="pr-1" md="6">
                     <FormGroup>
                         <label>اسم</label>
                         <Input
                         maxLength={20}
                           value={vtype.typeName.ar}
                         placeholder="اسم"
                         type="text"
                         onChange = {x => {
                            setVtype({...vtype , typeName : {...vtype.typeName , ar  :x.target.value }  })
                         }}
                         />
                     </FormGroup>
                     </Col>
             </Row>
          
             </CardHeader>
             <CardBody>
           
             </CardBody>
             <CardFooter>
                 <Button size="sm" color="primary" onClick={x => { setVtype({typeCode : "", typeName: { en : "", fr : "", ar : ""}})}} >New Type</Button>{' '}
                 <Button size="sm" color="warning" style={{float : "right"}} onClick={x => {
                    cinputConfirmAlert("Create or Update Vehicle Type")
                 }}>Update</Button>
             </CardFooter>
         </Card>
             
             
         </Col>
         <Col sm="12" md="7">
              <BtypeTable vtypeList={vtypeList}  removeType= {removeType} populateTypes={populateTypes} categories={categories}/>
                
            </Col>
        </Row>
        </div>
    )
}

export default Btype;